import { z } from "zod";
import apiRepresentation3dSchema from "./apiRepresentation3dSchema";
import { vector3dSchema } from "../primitivesSchema";

/* const holeProfilesSchema = z.array(
    z.array(vector3dSchema) // Each element is an array of vectors
  ); */

const apiTriangleMeshSchema = apiRepresentation3dSchema.extend({
    vertices: z.array(z.lazy(() => vector3dSchema)),
    indices: z.array( z.array(z.number()) ),
    normals: z.array( z.array(z.lazy(() => vector3dSchema) ))
  });

export default apiTriangleMeshSchema;